exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-dashed[data-v-47797142] {\n  border: 1px dashed #f5f5f5;\n  border-radius: 7px;\n}\n.bg-lighter[data-v-47797142] {\n  background: #f5f5f5;\n}\n", ""]);

// exports
